import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function PaymentResult({ success }) {
  const [params] = useSearchParams();
  const [status, setStatus] = useState(success ? "checking" : "cancel");

  useEffect(() => {
    document.body.classList.add("theme-light");
    return () => document.body.classList.remove("theme-light");
  }, []);

  useEffect(() => {
    const id = params.get("session_id");
    if (!success || !id) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired" || data.payment_status === "failed") return setStatus("failed");
      } catch {
        // retry
      }
      tries += 1;
      if (tries >= 15) return setStatus("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, success]);

  const content = {
    checking: [Loader2, "text-blue-600 animate-spin", "Confirmation du paiement…", ""],
    paid: [CheckCircle2, "text-green-600", "Abonnement activé", "Merci ! Vos techniciens peuvent se connecter aux machines."],
    failed: [XCircle, "text-red-600", "Paiement échoué", "Le paiement n'a pas abouti. Vous pouvez réessayer."],
    timeout: [Loader2, "text-amber-500", "Paiement en cours de traitement", "Revenez sur la page Abonnement dans quelques instants."],
    cancel: [XCircle, "text-slate-500", "Paiement annulé", "Aucun montant n'a été prélevé."],
  }[status];
  const [Icon, tone, title, text] = content;

  return (
    <div className="min-h-screen bg-[#F1F3F6] grid place-items-center p-6">
      <div className="bg-white rounded-xl border border-slate-200 p-10 text-center max-w-md" data-testid="payment-result">
        <Icon className={`h-12 w-12 mx-auto mb-4 ${tone}`} />
        <h1 className="text-2xl font-semibold mb-2" data-testid="payment-result-title">{title}</h1>
        <p className="text-slate-600 mb-6">{text}</p>
        <Button asChild><Link to="/app/billing" data-testid="payment-back-btn">Retour à l'abonnement</Link></Button>
      </div>
    </div>
  );
}
